module.exports = __webpack_public_path__ + "static/media/CheckedHeaderIcon.64b45cb4.svg";